import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
export function RealitySection() {
  return <section className="relative w-full bg-brand-mid py-20 md:py-28 overflow-hidden" data-id="element-165">
      {/* Accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent" data-id="element-166" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-167">
        <SectionReveal data-id="element-168">
          <p className="text-4xl mb-4" data-id="element-169">⚡</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-8 uppercase leading-tight" data-id="element-170">
            La mayoría de las personas no tiene un problema de ingresos…
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-171">
          <div className="bg-brand-gold/10 border-2 border-brand-gold/30 rounded-xl p-6 md:p-8 mb-8 inline-block" data-id="element-172">
            <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-brand-gold m-0" data-id="element-173">
              👉 Tiene un problema de gastos invisibles.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.25} data-id="element-174">
          <p className="text-xl sm:text-2xl text-gray-300 font-body" data-id="element-175">
            Y la luz es uno de los más grandes.
          </p>
        </SectionReveal>
      </div>
    </section>;
}